export default __webpack_public_path__ + "static/media/currency.0305a6df.svg";